import { render, staticRenderFns } from "./AssessmentDialog.vue?vue&type=template&id=1f7de25c&"
import script from "./AssessmentDialog.vue?vue&type=script&lang=js&"
export * from "./AssessmentDialog.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VContainer,VIcon,VLabel,VTextarea})
